import { buildTestIds, handleProductTag, useToast } from "application";
import { CountQuantityProduct, Image, ImagesProduct } from "components";
import { appMonitoringClient } from "implementations";
import dynamic from "next/dynamic";
import {
  // MouseEvent,
  useEffect,
  useState,
} from "react";
import { Price, Product, TagManager } from "typing";
import { theme } from "ui";
import {
  BoxCoupons,
  BoxPriceProduct,
  ButtonAddProductToWeddingList,
} from "../../components";
import { ButtonCartProps } from "../../components/ButtonCart";
import { ButtonCartUnavailableProps } from "../../components/ButtonCartUnavailable";
import SkeletonProduct from "./SkeletonProduct";
import {
  SelectPricePackage,
  SelectorOptions,
  ViewZipCodeSearch,
} from "./components";
import {
  BoxButtons,
  BoxTags,
  BoxValue,
  Container,
  FlexBoxCenter,
  HeaderBox,
  NameMarketplace,
  SectionBox,
  SubTitle,
  TagCampaignBoxProduct,
  TagProductPriceOnlySiteContainer,
  TagProductPriceOnlySiteText,
  TagProductWrapper,
  TagTextCampaignBoxProduct,
  Title1,
} from "./styles";

const ButtonCart = dynamic<ButtonCartProps>(() =>
  import("../../components/ButtonCart").then((module) => module)
);

const ButtonCartUnavailable = dynamic<ButtonCartUnavailableProps>(() =>
  import("../../components/ButtonCartUnavailable").then((module) => module)
);

type BoxProductProps = Partial<Omit<Product, "prices">> & {
  idProduct?: string;
  packageCurrentState?: Price;
  setPackageCurrent: React.Dispatch<Price | undefined>;
  actionAddItemCart: () => void;
  actionAddToGift: () => void;
  setProductQuantity: (quantity: number) => void;
  totalStockFC?: number;
  maximumStockPerBranch?: number;
  activeButtonWeddingList?: boolean;
  limitTotalQuantityItem?: number;
  sendingItemToCart: boolean;
  prices: Price[] | null | undefined;
  isBlackTheme: boolean;
  isBlackFriday?: boolean;
};

const BoxProduct = ({
  description,
  prices: PACKAGES_PRODUCT = [],
  mediaLinks = [],
  measuredUnity,
  factPackaged,
  productFamilies,
  tag,
  idProduct,
  packageCurrentState,
  setPackageCurrent,
  actionAddItemCart,
  setProductQuantity,
  totalStockFC,
  maximumStockPerBranch,
  actionAddToGift,
  activeButtonWeddingList = false,
  limitTotalQuantityItem,
  coupons,
  sendingItemToCart,
  isBlackTheme,
  isBlackFriday,
}: // eslint-disable-next-line sonarjs/cognitive-complexity
BoxProductProps) => {
  // const { isClientTablet } = useAppContext();
  const [quantityProductSelected, setQuantityProductSelected] =
    useState<number>(1);
  // const [isHovered, setIsHovered] = useState<boolean>(false);
  // const [isClicked, setIsClicked] = useState<boolean>(false);

  useEffect(() => {
    if (PACKAGES_PRODUCT?.length) {
      setPackageCurrent(PACKAGES_PRODUCT[0]);
    }
  }, [PACKAGES_PRODUCT, setPackageCurrent]);

  useEffect(() => {
    setProductQuantity(quantityProductSelected);
  }, [quantityProductSelected, setProductQuantity]);

  if (!idProduct) {
    appMonitoringClient.captureMessage(
      `O produto não possui um idProduct vinculado.`
    );
  }

  handleProductTag(idProduct as string, tag as TagManager, appMonitoringClient);

  if (!description) {
    return (
      <Container>
        <SkeletonProduct />
      </Container>
    );
  }

  const notShouldShowOldPriceAndDiscount =
    (packageCurrentState?.priceList as number) <
    (packageCurrentState?.salePrice as number);

  // const handleMouseEnter = () => {
  //   setIsHovered(true);
  // };

  // const handleMouseLeave = () => {
  //   setIsHovered(false);
  // };

  // const handleHeartClick = (event: MouseEvent<HTMLDivElement>) => {
  //   event.preventDefault();
  //   setIsClicked(!isClicked);
  // };

  const hasUnavailableStockPerBranch =
    maximumStockPerBranch === 0 ||
    Number(maximumStockPerBranch) <
      1 * (packageCurrentState?.packingQuantity ?? 1);
  const hasUnavailableTag = tag?.isUnavailable;
  const boxProductTestId = "box-product-box-value";

  return (
    <Container {...buildTestIds("box-product-container")}>
      {/* {isClientTablet && (
        <FavoriteContainer
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onClick={handleHeartClick}
        >
          <Heart
            isClientTablet={isClientTablet}
            isHovered={isHovered}
            isClicked={isClicked}
          />
        </FavoriteContainer>
      )} */}
      <SectionBox {...buildTestIds("image-box-section-box")}>
        <ImagesProduct
          {...buildTestIds("box-product-images-product")}
          mediaLinks={mediaLinks}
        />
      </SectionBox>
      <SectionBox {...buildTestIds("box-product-section-box")}>
        <HeaderBox>
          <TagProductWrapper>
            {isBlackTheme && (
              <BoxTags {...buildTestIds("box-product-box-tags")}>
                <TagCampaignBoxProduct
                  backgroundColor={theme.colors.blackFriday["125"]}
                  borderColor={theme.colors.blackFriday["125"]}
                  {...buildTestIds("tag-campaign-box-product")}
                >
                  <TagTextCampaignBoxProduct>
                    Oferta Black Friday
                  </TagTextCampaignBoxProduct>
                </TagCampaignBoxProduct>
              </BoxTags>
            )}
            {tag?.title ? (
              <BoxTags {...buildTestIds("box-product-box-tags")}>
                <TagProductPriceOnlySiteContainer backgroundColor={tag?.color}>
                  <TagProductPriceOnlySiteText>
                    {tag?.title}
                  </TagProductPriceOnlySiteText>
                </TagProductPriceOnlySiteContainer>
              </BoxTags>
            ) : null}
          </TagProductWrapper>
          {/* {!isClientTablet && (
              <FavoriteContainer
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                onClick={handleHeartClick}
              >
                <Heart isHovered={isHovered} isClicked={isClicked} />
              </FavoriteContainer>
            )} */}
          <Title1
            existSomeTag={Boolean(isBlackFriday || tag?.title)}
            {...buildTestIds("box-product-title")}
          >
            {description}
          </Title1>
          <FlexBoxCenter
            {...buildTestIds("box-product-flex-box-center")}
            className="new-product__sold"
          >
            <SubTitle {...buildTestIds("box-product-title-3")}>
              Vendido e entregue por
            </SubTitle>
            {packageCurrentState?.marketplace?.fantasy === "Ferreira Costa" ? (
              <Image
                {...buildTestIds("box-product-marketplace-image")}
                src="https://fercos-s3-ecommerce.s3.amazonaws.com/logo/logo_fc.svg"
                width="64px"
                height="16px"
                alt="logo marca da Ferreira Costa"
                layout="fixed"
              />
            ) : (
              <NameMarketplace
                {...buildTestIds("box-product-name-marketplace")}
              >
                {packageCurrentState?.marketplace?.fantasy}
              </NameMarketplace>
            )}
          </FlexBoxCenter>
        </HeaderBox>
        <BoxValue margin="2rem 0 0 0" {...buildTestIds("box-product-value")}>
          <BoxPriceProduct
            isBlackFriday={isBlackFriday}
            {...buildTestIds("box-product-box-price-product")}
            packageCurrentState={packageCurrentState}
            measuredUnity={measuredUnity}
            notShouldShowOldPriceAndDiscount={notShouldShowOldPriceAndDiscount}
          />
        </BoxValue>
        {(PACKAGES_PRODUCT as Price[])?.length > 1 && (
          <SelectPricePackage
            {...buildTestIds("box-product-select-price-package")}
            measuredUnity={measuredUnity}
            PACKAGES_PRODUCT={PACKAGES_PRODUCT as Price[]}
            packingSelection={packageCurrentState}
            setSelectPackage={setPackageCurrent}
          />
        )}
        {productFamilies?.length ? (
          <BoxValue {...buildTestIds(boxProductTestId)}>
            {productFamilies?.map(({ category, families }) => {
              if (families?.length === 1) {
                return null;
              }

              return (
                <SelectorOptions
                  {...buildTestIds("box-product-selector-options")}
                  key={category}
                  title={category}
                  data={families}
                />
              );
            })}
          </BoxValue>
        ) : null}

        {!hasUnavailableTag && !hasUnavailableStockPerBranch ? (
          <BoxValue margin="2rem 0 2rem 0" {...buildTestIds(boxProductTestId)}>
            <CountQuantityProduct
              {...buildTestIds("box-product-count-quantity-product")}
              limitQuantityItem={limitTotalQuantityItem}
              totalStockFC={totalStockFC}
              maximumStockPerBranch={maximumStockPerBranch}
              measuredUnity={measuredUnity}
              factPackaged={factPackaged}
              descriptionPackagingUnitPlural={
                packageCurrentState?.descriptionPackagingUnitPlural
              }
              descriptionPackagingUnitSingular={
                packageCurrentState?.descriptionPackagingUnitSingular
              }
              packingUnity={packageCurrentState?.packingUnity}
              packingQuantity={packageCurrentState?.packingQuantity}
              setProductQuantity={setQuantityProductSelected}
              debounceTime={0}
            />
          </BoxValue>
        ) : null}

        {coupons?.length ? (
          <BoxValue margin="2rem 0 2rem 0" {...buildTestIds(boxProductTestId)}>
            <BoxCoupons
              {...buildTestIds("box-product-box-coupons")}
              coupons={coupons}
              useToast={useToast}
            />
          </BoxValue>
        ) : null}

        <BoxButtons {...buildTestIds("box-product-box-buttons")}>
          {hasUnavailableTag || hasUnavailableStockPerBranch ? (
            <ButtonCartUnavailable
              {...buildTestIds("box-product-button-cart-unavailable")}
              buttonText={tag?.descriptionButton}
              buttonBgColor={tag?.buttonColor}
              unavailableDesc={tag?.descriptionReason}
              shouldShowUnavailableBoxIcon={!hasUnavailableStockPerBranch}
            />
          ) : (
            <>
              <ButtonCart
                {...buildTestIds("box-product-button-cart")}
                actionButton={actionAddItemCart}
                sendingItemToCart={sendingItemToCart}
              />
              {activeButtonWeddingList ? (
                <ButtonAddProductToWeddingList
                  {...buildTestIds(
                    "box-product-button-add-product-to-wedding-list"
                  )}
                  actionAddToGift={actionAddToGift}
                />
              ) : null}
            </>
          )}
        </BoxButtons>
        {!hasUnavailableTag && !hasUnavailableStockPerBranch ? (
          <ViewZipCodeSearch
            {...buildTestIds("box-product-view-zipCode-search")}
            quantityProductSelected={quantityProductSelected}
            packingLevel={packageCurrentState?.packingLevel}
            idProduct={idProduct}
            description={description}
            sellerId={packageCurrentState?.marketplace?.storeId as number}
          />
        ) : null}
      </SectionBox>
    </Container>
  );
};

export default BoxProduct;
